import React, { useEffect, useState } from "react";
import { Bell, Check } from "lucide-react";
import api from "@/lib/api";
import { useTranslation } from "react-i18next";
import {
  Popover, PopoverContent, PopoverTrigger,
} from "@/components/ui/popover";

export default function NotificationBell() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  const load = async () => {
    try {
      const r = await api.get("/notifications/me");
      setItems(r.data || []);
    } catch {}
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 30000);
    return () => clearInterval(id);
  }, []);

  const unread = items.filter((n) => !n.read).length;

  const markAllRead = async () => {
    try {
      await api.post("/notifications/read-all");
      load();
    } catch {}
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          data-testid="notif-bell"
          className="relative p-2 rounded-full hover:bg-slate-50 text-slate-700 transition-colors"
          aria-label="Notifications"
        >
          <Bell size={18} strokeWidth={1.5} />
          {unread > 0 && (
            <span data-testid="notif-badge" className="absolute top-1 right-1 w-2 h-2 rounded-full bg-rose-500 ring-2 ring-white" />
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" sideOffset={8} className="w-80 p-0 bg-white border-slate-100 shadow-xl rounded-2xl">
        <div className="flex items-center justify-between p-4 border-b border-slate-100">
          <div className="text-sm font-medium">{t("notifications.title")}</div>
          {unread > 0 && (
            <button data-testid="notif-mark-read" onClick={markAllRead} className="text-xs text-seafoam hover:underline flex items-center gap-1">
              <Check size={12} /> {t("notifications.mark_read")}
            </button>
          )}
        </div>
        <div className="max-h-96 overflow-y-auto">
          {items.length === 0 ? (
            <div className="p-6 text-center text-sm text-slate-400">{t("notifications.empty")}</div>
          ) : (
            items.map((n) => (
              <div key={n.notification_id} className={`p-4 border-b border-slate-50 ${!n.read ? "bg-slate-50/60" : ""}`}>
                <div className="text-sm font-medium text-slate-900">{n.title}</div>
                <div className="text-xs text-slate-600 mt-1">{n.body}</div>
                <div className="text-[10px] text-slate-400 mt-2 uppercase tracking-wider">{new Date(n.created_at).toLocaleString()}</div>
              </div>
            ))
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
